m = require 'mithril'

CommonViews = require '../components/CommonViews'
Breadcrumbs = require '../components/Breadcrumbs'

SettingsPage = {
	view: () ->
		CommonViews.page [
			m Breadcrumbs, {items: [
				{url: '/', label: 'Games', icon: CommonViews.icons.home}
				{label: 'Settings'}
			]}

			CommonViews.pageHeading 'Settings'

			m 'p', 'Manage your settings and data:'

			m 'ul', [
				m 'li', m 'a', {config: m.route, href: '/settings/data'}, 'Data Import/Export'
			]
		]
}

module.exports = (store) ->
	m SettingsPage, {}